import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { font } from "../styles/font";
import { theme } from "../styles/theme";

export const SideBanner = ({query}) =>{
    return(
        <>
         <Box
          display={query ? "none" : "flex"}
          width="35%"
          alignItems="center"
          justifyContent="center"
          height={"100%"}
          sx={{
            backgroundImage:
              "url(https://mindamigo.com/wp-content/uploads/2023/04/abous-us-mindamigo-min.png)",
            backgroundSize: "cover",
          }}
        >
          <Typography
          backgroundColor={theme.col_2_alpha}
            fontFamily={font.family.fm_2}
            color={theme.col_4}
            fontSize={font.size.fs_1}
            textAlign="center"
            fontWeight="bold"
          >
            Welcome to Mindamigo
          </Typography>
        </Box>
        </>
    )
}